import Head from "next/head";
import { useRouter } from "next/router";
import { type ReactNode, useEffect, useState } from "react";
import { BotControlProvider } from "@medbillai/app/screens/auth/components/BotControlProvider";
import { LoginScreen } from "@medbillai/app/screens/auth/login";
import { SignUpOnboardingLayout } from "@medbillai/app/screens/sign-up-onboarding/layout.web";
import { FullscreenSpinner, isWeb } from "@medbillai/ui";
import { SlidingLayout } from "../utils/transition/SlidingLayout";
// Adjusted import to resolve error
import type { NextPageWithLayout } from "./_app";
const Page: NextPageWithLayout = () => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (router.isReady) {
      setIsLoading(false);
    }
  }, [router.isReady]);
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="login.tsx">
        <title>Login</title>
      </Head>
      {isLoading && isWeb !== undefined ? <FullscreenSpinner /> : <LoginScreen />}
    </>;
};

// The 2-col signup hero is a v3.0 design element — control (v2) users and
// direct /login visits keep the single-column login unchanged. The v3 shell
// hands off with `?variant=signup` (like v2's intent variants), so the gate
// is pure URL state: refresh-proof, and no flag evaluation on this route.
const LoginLayout = ({
  children
}: {
  children: ReactNode;
}) => {
  const {
    query
  } = useRouter();
  return <SignUpOnboardingLayout heroImageSrc={query.variant === "signup" ? "/static/onboarding/signup-hero.jpg" : undefined} data-sentry-element="SignUpOnboardingLayout" data-sentry-component="LoginLayout" data-sentry-source-file="login.tsx">
      {children}
    </SignUpOnboardingLayout>;
};
Page.getLayout = page => <LoginLayout>
    <SlidingLayout>
      <BotControlProvider>{page}</BotControlProvider>
    </SlidingLayout>
  </LoginLayout>;
export default Page;